var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.862 7.21107H1.08054C1.03606 7.21107 1 7.24713 1 7.29161V12.2055C1 12.2499 1.03606 12.286 1.08054 12.286H6.862C6.90648 12.286 6.94254 12.3221 6.94254 12.3665V14.142C6.94254 14.2092 7.01994 14.2468 7.07279 14.2053L12.7656 9.73791C12.8066 9.70575 12.8067 9.64375 12.7659 9.61141L7.07307 5.10337C7.02028 5.06156 6.94254 5.09916 6.94254 5.16651V7.13053C6.94254 7.17501 6.90648 7.21107 6.862 7.21107Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5625 12.288H22.9195C22.9639 12.288 23 12.324 23 12.3685V17.2824C23 17.3269 22.9639 17.3629 22.9195 17.3629H17.5625C17.518 17.3629 17.4819 17.399 17.4819 17.4434V19.211C17.4819 19.2795 17.4018 19.3167 17.3494 19.2725L12.0726 14.813C12.0347 14.7809 12.0345 14.7224 12.0723 14.6902L17.3491 10.1902C17.4014 10.1456 17.4819 10.1827 17.4819 10.2514V12.2074C17.4819 12.2519 17.518 12.288 17.5625 12.288Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.cba56808c36be67ff2c406d7bb60ee2c.svg";
export { ForwardRef as ReactComponent };